import { Component, OnInit, OnDestroy, HostListener, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicTranslationService, Language } from '@gs-2.0/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss']
})
export class LanguageSwitcherComponent implements OnInit, OnDestroy {
  languages: Language[] = [];
  currentLanguage: Language | null = null;
  isDropdownOpen = false;
  private subscriptions = new Subscription();
  @Output() langDropdownOpen = new EventEmitter<boolean>();

  constructor(
    private translationService: DynamicTranslationService
  ) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.language-switcher')) {
      this.isDropdownOpen = false;
    }
  }

  ngOnInit(): void {
    // Subscribe to available languages from DynamicTranslationService
    // (which now gets them from GeneralService internally)
    this.subscriptions.add(
      this.translationService.languages$.subscribe(languages => {
        if (languages && languages.length > 0) {
          this.languages = languages;
        }
      })
    );

    // Subscribe to current language from translation service
    this.subscriptions.add(
      this.translationService.currentLanguage$.subscribe(lang => {
        if (lang) {
          this.currentLanguage = lang;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
    this.langDropdownOpen.emit(this.isDropdownOpen)
  }

  selectLanguage(language: Language): void {
    if (!this.currentLanguage || language.code !== this.currentLanguage.code) {
      // Save language selection to localStorage
      localStorage.setItem('selectedLanguage', language.code);
      this.isDropdownOpen = false;

      // Switch language dynamically without page reload
      // This is much faster and provides better UX
      this.translationService.setCurrentLanguage(language);
    } else {
      this.isDropdownOpen = false;
    }
  }
}
